module.exports = __webpack_public_path__ + "img/8.dc0dc874.jpg";